import React from "react";
import styled from "styled-components";

/**
 * チャットのメッセージバブルコンポーネント
 */
const ChatMessage = ({ message }) => {
  const isUser = message.role === "user";
  const isError = message.isError;

  // 改行を <br> に変換
  const renderContent = (text) => {
    return text.split("\n").map((line, i) => (
      <React.Fragment key={i}>
        {line}
        {i < text.split("\n").length - 1 && <br />}
      </React.Fragment>
    ));
  };

  return (
    <MessageRow $isUser={isUser}>
      {!isUser && (
        <Avatar $isUser={false}>
          <span>AI</span>
        </Avatar>
      )}
      <Bubble $isUser={isUser} $isError={isError}>
        {renderContent(message.content)}
      </Bubble>
      {isUser && (
        <Avatar $isUser={true}>
          <span>👤</span>
        </Avatar>
      )}
    </MessageRow>
  );
};

const MessageRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: ${({ $isUser }) => ($isUser ? "flex-end" : "flex-start")};
  gap: 8px;
  margin-bottom: 12px;
`;

const Avatar = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: ${({ $isUser }) => ($isUser ? "#2397ce" : "#192e55")};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;

  span {
    font-size: 10px;
    color: white;
    font-weight: bold;
  }
`;

const Bubble = styled.div`
  max-width: 80%;
  padding: 10px 14px;
  border-radius: ${({ $isUser }) =>
    $isUser ? "16px 4px 16px 16px" : "4px 16px 16px 16px"};
  background-color: ${({ $isUser, $isError }) => {
    if ($isError) return "#fff0f0";
    return $isUser ? "#2397ce" : "#f0f7fc";
  }};
  color: ${({ $isUser, $isError }) => {
    if ($isError) return "#d32f2f";
    return $isUser ? "#ffffff" : "#192e55";
  }};
  font-size: 12px;
  line-height: 1.6;
  word-break: break-word;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  border: ${({ $isError }) => ($isError ? "1px solid #ffcdd2" : "none")};
`;

export default ChatMessage;
